import React, { useState } from 'react';
import type { DatePickerProps, MenuProps } from 'antd';
import {
    Button,
    DatePicker,
    Divider,
    Dropdown,
    Input,
    Select,
    Space
} from 'antd';
import { documentTypeOptions } from './filterOptions';
import { contentStyle, headingStyle, menuStyle, subStyle } from './filterStyle';
import CustomModal from '../../CustomModal';
import { SuitUIButton } from '../../SuitUIButton';
import { FilterIcon } from '../../icons';

interface IProps {
    setFilterOptions: any;
    filterOptions: any;
    fetchDocuments: any;
}

const FilterTradeDocuments: React.FC<IProps> = ({
    setFilterOptions,
    filterOptions,
    fetchDocuments
}): JSX.Element => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const onChangeTo: DatePickerProps['onChange'] = (date, dateString) => {
        setFilterOptions({
            ...filterOptions,
            createdDateTo: date?.format('YYYY-MM-DD HH:mm:ss')
        });
    };

    const onChangeFrom: DatePickerProps['onChange'] = (date, dateString) => {
        setFilterOptions({
            ...filterOptions,
            createdDateFrom: date?.format('YYYY-MM-DD HH:mm:ss')
        });
    };

    const onOk = (value: DatePickerProps['value']) => {
        console.log('onOk:');
    };

    const items = [
        {
            key: '1',
            label: (
                <div>
                    <label className='font-medium text-sm text-steelBlue leading-6'>
                        Amount Range
                    </label>
                    <div className='flex items-center gap-[12px]'>
                        <DatePicker
                            placeholder='Start Date'
                            onChange={onChangeFrom}
                            showTime={{ format: 'HH:mm' }}
                            format='YYYY-MM-DD'
                            onOk={onOk}
                            className='h-[40px] w-full'
                        />
                        <DatePicker
                            showTime={{ format: 'HH:mm' }}
                            format='YYYY-MM-DD'
                            placeholder='End Date'
                            onChange={onChangeTo}
                            onOk={onOk}
                            style={{ width: '100%' }}
                            className='h-[40px] w-full'
                        />
                    </div>
                </div>
            )
        },
        {
            type: 'divider'
        },
        {
            key: '2',
            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='inline-block font-medium text-sm text-steelBlue leading-6'>
                        Document Name
                    </label>
                    <Input
                        type='text'
                        value={filterOptions?.documentName}
                        onChange={(e) =>
                            setFilterOptions({
                                ...filterOptions,
                                documentName: e.target.value
                            })
                        }
                        className='h-[40px] w-full'
                    />
                </div>
            )
        },
        {
            type: 'divider'
        },
        {
            key: '3',
            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='inline-block font-medium text-sm text-steelBlue leading-6'>
                        Document Type
                    </label>
                    <Select
                        style={{ width: '100%' }}
                        size='large'
                        options={documentTypeOptions}
                        value={filterOptions?.documentType}
                        onChange={(value: string) =>
                            setFilterOptions({
                                ...filterOptions,
                                documentType: value
                            })
                        }
                        className='h-[40px] w-full'
                    />
                </div>
            )
        },
        {
            type: 'divider'
        },
        {
            key: '4',
            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='inline-block font-medium text-sm text-steelBlue leading-6'>
                        Data Type
                    </label>
                    <Select
                        style={{ width: '100%' }}
                        size='large'
                        value={filterOptions?.createdType}
                        onChange={(value: string) =>
                            setFilterOptions({
                                ...filterOptions,
                                createdType: value
                            })
                        }
                        options={[
                            { value: 'CREATED', label: 'Form' },
                            { value: 'UPLOADED', label: 'File' }
                        ]}
                    />
                </div>
            )
        }
    ];

    const handleMenuClick = () => {
        fetchDocuments(filterOptions);
        setDropdownVisible(false);
    };

    const handleButtonClick = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const dropdownItems = items as MenuProps['items'];

    return (
        <>
            <div className='hidden lg:block'>
                <Dropdown
                    menu={{ items: dropdownItems }}
                    trigger={['click']}
                    visible={dropdownVisible}
                    overlayStyle={{
                        pointerEvents: 'auto'
                    }}
                    dropdownRender={(menu) => (
                        <div className='hidden lg:block' style={contentStyle}>
                            <h2 style={headingStyle}>Filters</h2>
                            <p style={subStyle}>
                                Filters will be added to the table.
                            </p>
                            {React.cloneElement(menu as React.ReactElement, {
                                style: menuStyle
                            })}
                            <Divider style={{ margin: 0 }} />
                            <Space
                                style={{
                                    padding: '1rem',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}
                            >
                                <Button
                                    className='reset-btn'
                                    onClick={() => {
                                        setFilterOptions({});
                                        fetchDocuments({});
                                        setDropdownVisible(false);
                                    }}
                                >
                                    Reset
                                </Button>
                                <Button
                                    className='bg-appcolorprimarydeep text-appcolorwhite border-0 hover:bg-appcolorwhite hover:border-appcolorprimarydeep hover:border  hover:text-appcolorprimary'
                                    onClick={handleMenuClick}
                                >
                                    Apply Filter
                                </Button>
                            </Space>
                        </div>
                    )}
                >
                    <div
                        className='tab-buttons hidden lg:block'
                        onClick={handleButtonClick}
                    >
                        <img
                            src='/img/vectors/plainfilter.svg'
                            alt='plainfilter'
                        />
                        <p style={{ paddingRight: '5px' }}>Filter</p>
                    </div>
                </Dropdown>
            </div>
            <div className='lg:hidden w-[100vw]'>
                <CustomModal
                    maxWidth='lg'
                    open={modalVisible}
                    onClose={() => setModalVisible(false)}
                    hideCloseIcon
                >
                    <div className='lg:hidden w-full  px-[16px] pt-[40px]'>
                        <h2 className='text-ebony mb-[16px]'>Filters</h2>

                        {items?.map((item) => item?.label)}

                        <div className='flex justify-between pt-[40px] pb-[80px]'>
                            <SuitUIButton
                                text='Cancel'
                                onClick={() => setModalVisible(false)}
                                invert
                                style='h-[40px] border border-gray300 text-steelBlue font-medium text-sm leading-[20px]'
                            />
                            <div className='flex gap-[24px]'>
                                <SuitUIButton
                                    text='Reset'
                                    onClick={() => {
                                        setFilterOptions({});
                                        fetchDocuments({});
                                    }}
                                    variant='secondary'
                                />
                                <SuitUIButton
                                    text='Apply Filter'
                                    onClick={handleMenuClick}
                                    style='h-[40px]'
                                />
                            </div>
                        </div>
                    </div>
                </CustomModal>
                <button
                    className='flex items-center h-[52px] w-[150px] gap-[16px] text-steelBlue text-base lg:h-[unset] lg:w-[unset] lg:text-black lg:text-sm lg:gap-[unset] lg:mx-2'
                    onClick={() => setModalVisible(true)}
                >
                    <FilterIcon />
                    Filter
                </button>
            </div>
        </>
    );
};

export default FilterTradeDocuments;
